// extracted by mini-css-extract-plugin
export default {"opening-hours-box":"OpeningHoursBox_opening-hours-box__du3UV","error":"OpeningHoursBox_error__L6Z+j"};